import { Line, mixins } from 'vue-chartjs'
// import labels
import ChartJsPluginDataLabels from "chartjs-plugin-datalabels";
// import annotation
import ChartJsPluginAnnotation from "chartjs-plugin-annotation";

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  // props: ['options'],
  components: {
    ChartJsPluginDataLabels,
    ChartJsPluginAnnotation,
  },
  data() {
    return {
      //Chart.js options that control the appearance of the chart
      options: {
        layout: {
          padding: {
            left: 25,
            right: 25,
            top: 0,
            bottom: 100
          }
        },
        plugins: {
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            color: "white",
            padding: 4,
            font: {
              size: 10,
              weight: "bold"
            }
          }
        },
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 74,
              borderColor: "red",
              borderWidth: 2,
              borderDash: [2, 2],
              label: {
                // Background color of label, default below
                backgroundColor: "rgb(255, 99, 132)",
                // Font family of text, inherits from global
                fontFamily: "sans-serif",
                // Font size of text, inherits from global
                fontSize: 10,
                // Font style of text, default below
                fontStyle: "bold",
                // Font color of text, default below
                fontColor: "#fff",
                // Padding of label to add left/right, default below
                xPadding: 6,
                // Padding of label to add top/bottom, default below
                yPadding: 6,
                // Radius of label rectangle, default below
                cornerRadius: 6,
                // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                // position: "left",
                // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                // For horizontal lines positioned left or right, negative values move
                // the label toward the edge, and positive values toward the center.
                xAdjust: 0,
                // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                // For vertical lines positioned top or bottom, negative values move
                // the label toward the edge, and positive values toward the center.
                yAdjust: 0,
                // Whether the label is enabled and should be displayed
                enabled: true,
                // Text to display in label - default is null
                content: null
              }
            },
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 49,
              borderColor: "red",
              borderWidth: 2,
              borderDash: [2, 2],
              label: {
                // Background color of label, default below
                backgroundColor: "rgb(255, 99, 132)",
                // Font family of text, inherits from global
                fontFamily: "sans-serif",
                // Font size of text, inherits from global
                fontSize: 10,
                // Font style of text, default below
                fontStyle: "bold",
                // Font color of text, default below
                fontColor: "#fff",
                // Padding of label to add left/right, default below
                xPadding: 6,
                // Padding of label to add top/bottom, default below
                yPadding: 6,
                // Radius of label rectangle, default below
                cornerRadius: 6,
                // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                // position: "left",
                // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                // For horizontal lines positioned left or right, negative values move
                // the label toward the edge, and positive values toward the center.
                xAdjust: 0,
                // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                // For vertical lines positioned top or bottom, negative values move
                // the label toward the edge, and positive values toward the center.
                yAdjust: 0,
                // Whether the label is enabled and should be displayed
                enabled: true,
                // Text to display in label - default is null
                content: null
              }
            }
          ]
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: 90
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              // type: 'category',
              offset: false,
              gridLines: {
                display: true
              },
              ticks: {
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90
              }
            }
          ]
        },
        legend: {
          display: true,
          position: 'top',
          fullWidth: true,
          align: 'center',
          labels: {
            boxWidth: 10,
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}